(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('priceCalculationWorkflow', priceCalculationWorkflow);

    priceCalculationWorkflow.$inject = ['$q', '$log', 'pricingService', 'priceCalculationErrorHandler'];

    function priceCalculationWorkflow($q, $log, pricingService, priceCalculationErrorHandler) {

        function instance() {
            this.salesPrice = {
                state: 'Draft',
                issue: null,

                isCalculating: function () {
                    return this.state === 'Calculating';
                },
                isReady: function () {
                    return this.state === 'Complete';
                },
                hasPrice: function () {
                    return this.isReady() && !this.issue;
                }
            };
        }

        instance.prototype = {
            calculate: calculate
        };

        return {
            Instance: instance
        };

        // -------------------------------------------------------------------------------------

        function calculate(productInfo, currencyId, canceler) {
            var self = this;
            var request = angular.extend({ currencyId: currencyId }, productInfo);

            return runCalculating.call(self, request, canceler);
        }

        function runCalculating(request, canceler) {
            var self = this;
            $log.debug('Run price calculating workflow; materialId: ' + request.materialId + '; colourId: ' + request.colourId);

            var tasks =
            [
                validate,
                getSalesPrice
            ];

            var flow = $q.resolve(request);
            _.each(tasks, function (task) {
                flow = flow.then(function (result) {
                    return task.call(self, result, canceler);
                });
            });

            flow = flow.finally(function () {
                $log.debug('FINISHED price calculating workflow; materialId: ' + request.materialId + '; colourId: ' + request.colourId);

                self.salesPrice.state = 'Complete';

                return self.salesPrice;
            });

            flow = flow.catch(handleException.bind(self));

            return flow;
        }

        // ------------------------------------------------------------------------------------

        function handleException(reason) {
            $log.debug("Workflow stopped. Reason: ", reason);
            var self = this;

            if (reason === 'CANCELED') {
                self.salesPrice.state = 'Canceled';
            } else {
                self.salesPrice.issue = priceCalculationErrorHandler.handle(reason);
            }

            return $q.reject(reason);
        }

        // ############################################ Tasks ############################################

        // ------------------------------------------ validate ------------------------------------------

        function validate(productInfo) {
            if (!productInfo.modelId) {
                throw 'Invalid productInfo. Model id is missing.';
            }

            if (!productInfo.materialId) {
                throw 'Invalid productInfo. Material id is missing.';
            }

            if (!productInfo.colourId) {
                throw 'Invalid productInfo. Colour id is missing.';
            }

            if (!productInfo.scale) {
                throw 'Invalid productInfo. Scale is missing.';
            }

            if (!productInfo.quantity) {
                throw 'Invalid productInfo. Quantity is missing.';
            }

            if (!productInfo.productTemplateId) {
                throw 'Invalid productInfo. ProductTemplateId is missing.';
            }

            if (!productInfo.currencyId) {
                throw 'Invalid productInfo. Currency id is missing.';
            }

            return $q.resolve(productInfo);
        }

        // ------------------------------------------ getSalesPrice ------------------------------------------

        function getSalesPrice(productInfo, canceler) {
            var self = this;

            self.salesPrice.state = 'Calculating';

            return pricingService.getSalesPrice(productInfo.modelId, productInfo.materialId, productInfo.colourId, productInfo.scale,
                productInfo.quantity, productInfo.productTemplateId, productInfo.currencyId, canceler)
                .then(function (salesPrice) {
                    angular.extend(self.salesPrice, salesPrice);
                });
        }
    }
}());